/** FAQ items for `/use-cases/presentations` page. */

export const PRESENTATIONS_FAQ_ITEMS = [
  {
    question: 'Нужна ли установка?',
    answer: 'Нет. preztimer работает в браузере на компьютере, планшете и телефоне.',
  },
  {
    question: 'Можно ли начать без аккаунта?',
    answer: 'Да. Можно создать гостевую комнату и сразу начать работу.',
  },
  {
    question: 'Можно ли автоматизировать переходы между таймерами?',
    answer:
      'Нет. Автопереходов между таймерами нет: запуск, пауза и переход к следующему таймеру выполняются вручную. Во время выступления можно добавить или убавить время быстрыми кнопками.',
  },
  {
    question: 'Работает ли сервис без интернета?',
    answer: 'Нет. Для синхронизации панели управления и экрана таймера нужен интернет.',
  },
  {
    question: 'Подходит ли это для онлайн- и гибридных выступлений?',
    answer:
      'Да. Спикер может открыть экран таймера по ссылке на своём устройстве, а организатор — управлять с панели на другом устройстве.',
  },
] as const;
